import { render, staticRenderFns } from "./CmgNutritionCalculatorMealBuilderBanner.vue?vue&type=template&id=03ddb800&scoped=true&lang=pug&"
import script from "./cmg-nutrition-calculator-meal-builder-banner.ts?vue&type=script&lang=ts&"
export * from "./cmg-nutrition-calculator-meal-builder-banner.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNutritionCalculatorMealBuilderBanner.vue?vue&type=style&index=0&id=03ddb800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ddb800",
  null
  
)

export default component.exports